// export const BASE_URL = "http://localhost:4000/api/v1"
// export const BASE_URL = "https://shiny-bear-vestments.cyclic.app/api/v1"
export const BASE_URL = "https://cute-plum-stingray-yoke.cyclic.app/api/v1"
